module.exports = __webpack_public_path__ + "img/json.db823c56.png";